import script from "./BogoInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./BogoInfo.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__